import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "option", "tooltipMessage"];
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const SelectOptionWithTooltip = _ref => {
  let {
      children,
      option,
      tooltipMessage
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
    children: /*#__PURE__*/_jsx(Tooltip, {
      disabled: !option.disabled,
      title: tooltipMessage,
      autoPlacement: false,
      placement: "left" //this oddly puts it further left...
      ,
      children: /*#__PURE__*/_jsx(_Fragment, {
        children: children
      })
    })
  }));
};